export default function LoadingScreen() {
    return (
        <div className="loading-screen">
            <div className="loader-container">
                <div className="spinner"></div>
            </div>
        </div>
    )
}